<template>
  <ag-card-container
    :search.sync="search"
    title="Liste des types d'opérations"
    fluid
    no-content-padding
  >
    <template #left>
      <v-btn
        color="success"
        fab
        x-small
        :loading="loadingExport"
        @click="exportExcel"
      >
        <v-icon>file_download</v-icon>
      </v-btn>
    </template>

    <operation-type-list
      :value="operationTypeList"
      :selected.sync="selectedOperationTypeList"
      :loading="loadingData"
      :search="search"
    >
      <template #footer>
        <v-btn
          color="accent"
          outlined
          small
          append
          to="restore"
        >
          éléments supprimés
        </v-btn>
      </template>
    </operation-type-list>

    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedOperationTypeList.length"
        title="Confirmation"
        :message="removeMessage"
        cancel-label="Annuler"
        confirm-label="Supprimer"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedOperationTypeList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="create"
        append
        color="accent"
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import { createExcelFile } from 'src/services/drawExcelService'
import OperationTypeList from '../components/OperationTypeList'

export default {
  name: 'OperationTypeListContainer',
  components: {
    AgCardContainer,
    AgFloatButtonContainer,
    AgConfirmDialog,
    OperationTypeList,
  },
  data: () => ({
    operationTypeList: [],
    selectedOperationTypeList: [],
    search: '',
    loadingData: false,
    loadingRemove: false,
    loadingExport: false,
  }),
  computed: {
    removeMessage () {
      const count = this.selectedOperationTypeList.length
      return `Souhaitez-vous supprimer ${count} type(s) d'opération(s)`
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'OperationTypeList' || !this.operationTypeList.length) {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      try {
        this.loadingData = true
        this.operationTypeList = await Repositories.operationType.getList({ archived: false })
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingData = false
      }
    },
    async removeSelected () {
      try {
        this.loadingRemove = true
        const count = this.selectedOperationTypeList.length
        await Repositories.operationType.delete(
          this.selectedOperationTypeList.map(select => select._id),
        )
        this.showSuccessNotification(`Vous avez supprimé ${count} type(s) d'opération(s)`)
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingRemove = false
        this.selectedOperationTypeList = []
        this.fetchData()
      }
    },
    async exportExcel () {
      try {
        this.loadingExport = true
        const exportConfig = {
          columns: [
            { header: 'Nom', key: 'name' },
            { header: 'Description', key: 'description' },
            { header: 'Opération parallèle', key: 'control' },
            { header: 'Saisir plusieur pièces', key: 'multiParts' },
            { header: 'Retouche autorisé', key: 'alterationAllowed' },
            { header: 'Opération de retouche', key: 'alteration' },
            { header: 'Délais activé', key: 'isDelay' },
            { header: 'Délais', key: 'delay' },
            { header: 'Catégorie d\'opération', key: 'categoryName' },
            { header: 'Id', key: '_id' },
          ],
          view: [{ state: 'frozen', xSplit: 1, ySplit: 1 }],
          sheetName: 'Liste des types d\'opération',
        }
        const data = this.operationTypeList.map(item => ({
          _id: item._id,
          name: item.name,
          description: item.description,
          control: item.control,
          multiParts: item.multiParts,
          alterationAllowed: item.alterationAllowed,
          alteration: item.alteration,
          isDelay: item.isDelay,
          delay: item.delay,
          categoryName: item.category ? item.category.name : '',
        }))
        await createExcelFile([{ dataToExport: data, config: exportConfig }], 'Liste des types d\'opération')
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loadingExport = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
